import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

// From backend-register : at least 8 characters AND one special char AND one letter
const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

// TODO : add the code regex

const zNewResetPasswordForm = z.object({
  code: z
    .string()
    .min(6, { message: 'Le code doit contenir 6 caractères' })
    .max(6, { message: 'Le code doit contenir 6 caractères' }),
  email: z.string().email({ message: "L'adresse email est invalide" }),
  newPassword: z
    .string()
    .min(8, { message: 'Le mot de passe doit contenir au minimum 8 caractères' })
    .regex(PASSWORD_REGEX, {
      message: 'Le mot de passe doit contenir au moins un chiffre et un caractère spécial.',
    }),
})

export type NewResetPasswordForm = z.infer<typeof zNewResetPasswordForm>

// Form hook
export const useResetPasswordForm = () => {
  const form = useForm<NewResetPasswordForm>({
    // Validation function
    defaultValues: {
      email: '',
      newPassword: '',
      code: '',
    },
    resolver: zodResolver(zNewResetPasswordForm),
  })

  return form
}
